'use strict'

import auth from './auth'
import storage from './storage'
import lists from './lists'
import sample from './sample'
import probePlex from './probePlex'
import plate from './plate'

import seq from './seq'

export default {
	auth: auth,
	lists: lists,
	sample: sample,
	probePlex: probePlex,
	plate: plate,
	seq: seq,
	storage: storage,
}